import React from 'react'
import Layout from '@components/layouts/Layout'
import { useAuth0 } from '@auth0/auth0-react'
import Prompt from '@components/Prompt'
import Index from '@components/pages/public/Index'
const Page: React.FC<{}> = () => {
  const { user } = useAuth0()
  return (
    <Layout page="INDEX" pageTitle={user ? 'BUILDER' : undefined}>
      {user ? <Prompt /> : <Index />}
    </Layout>
  )
}

export default Page
